module.exports = __webpack_public_path__ + "img/profile-img.18609d63.jpg";